import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./SlidesMain.module.scss";
import PathContext from "../../context/path";
import StateContext from "../../context/state";
const SlidesMain = () => {
  const path = useContext(PathContext);
  const state = useContext(StateContext);
  const { updateAllStages, stage, updateStage, updatePlayPopup, transition, isMobile } = state;
  const refSlides = useRef(null);
  const [currentStage, setCurrentStage] = useState(-1);
  const [reverse, setReverse] = useState(false);

  const [init, setInit] = useState(false);

  useEffect(() => {
    setInit(false);
  }, [isMobile]);
  useEffect(() => {
    if (!init) {
      setInit(true);
      const slides = refSlides.current.children;
      let countArray = [];
      let counter = 0;
      for (const child of slides) {
        delete child.dataset.slide;
        if (isMobile) {
          child.dataset.slide = counter;
          countArray.push(child);
          counter++;
        } else if (!child.classList.contains(styles.slide_mobile)) {
          child.dataset.slide = counter;
          countArray.push(child);
          counter++;
        }
      }
      updateAllStages(countArray.length);
    }
  }, [init, isMobile, updateAllStages]);

  useEffect(() => {
    let diff = currentStage > stage;
    if (!transition && diff) {
      setReverse(true);
    } else {
      setReverse(false);
    }
  }, [currentStage, stage, transition]);
  useEffect(() => {
    let diff = currentStage - stage;
    let timer = null, prevTimer = null;
    if (diff !== 0) {
      const slides = Array.from(refSlides.current.children);
      const prevSlide = slides.filter((item) => item.classList.contains(styles.active));
      if (prevSlide[0] !== undefined) {
        setTimeout(() => {
          prevSlide[0].classList.remove(styles.active);
        }, 500);
        const orderList = prevSlide[0].querySelectorAll('[data-animation-order]');
        if (orderList.length > 0) {
          orderList.forEach(element => {
            element.classList.remove(styles.shown);
          });
        }
      }
    }
    if (reverse && !transition) {
      setCurrentStage(stage);
    }
    if (diff < 0) {
      timer = setTimeout(() => {
        setCurrentStage(stage);
      }, 500);
    }
    return () => {

      // clearInterval(prevTimer);
      clearInterval(timer);
    }
  }, [stage, currentStage, reverse, transition]);

  useEffect(() => {
    const slides = Array.from(refSlides.current.children);
    const currentSlide = slides.filter((item) => parseInt(item.dataset.slide, 10) === currentStage);
    if (currentSlide[0] !== undefined) {
      const orderList = currentSlide[0].querySelectorAll('[data-animation-order]');
      currentSlide[0].classList.add(styles.active);
      if (orderList.length > 0) {
        orderList.forEach(element => {
          setTimeout(() => {
            element.classList.add(styles.shown);
          }, element.dataset.animationOrder * 150);
        });
      }
    }
  }, [currentStage]);

  return (
    <>


      <div className={styles.wrap} ref={refSlides}>
        <div className={`${styles.slide} ${styles.slide_0}`}>
          <div className={styles.container}>
            <div className={styles.desc} data-animation-order={0}>
              <span>Путешествие </span>
              <span>поезда </span>
              <span>из </span>
              <span>Китая </span>
              <span>в Европу</span>
            </div>
            <h1 className={styles.h1} data-animation-order={1}>
              <span>Как </span>
              <span>мы </span>
              <span>перевозим </span>
              <span>грузы </span>
            </h1>
            <div className={styles.btn} data-animation-order={2}>
              <img src={`${path}/img/icon-hand.svg`} alt="" />
              <div className={styles.btn__text}>
                <div className={styles.btn__inner}>Свайп вправо для навигации</div>
              </div>

            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_1}`}>
          <div className={styles.container}>
            <div className={styles.text} data-animation-order={0}>
              <span>В </span>
              <span>эту </span>
              <span>минуту </span>
              <span>очередной </span>
              <span>контейнерный </span>
              <span>поезд </span>
              <span>в сервисе </span>
              <span>ОТЛК </span>
              <span>ЕРА </span>
              <span>отправляется </span>
              <span>в путь </span>
              <span>по транзитному </span>
              <span>маршруту</span>
            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_2}`}>
          <div className={styles.container}>
            <div className={styles.text} data-animation-order={0}>
              <span>Ему </span>
              <span>предстоит </span>
              <span>преодолеть </span>
              <span>расстояние </span>
              <span>в 5400 км </span>
              <span>и пересечь </span>
              <span>несколько </span>
              <span>границ</span>
            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_3}`}>
          <div className={styles.container}>
            <div className={styles.text} data-animation-order={0}>
              <span>Как </span>
              <span>поезд </span>
              <span>проезжает </span>
              <span>такие </span>
              <span>огромные </span>
              <span>расстояния </span>
              <span>без остановок?</span>
            </div>
            <div className={styles.text} data-animation-order={1}>
              <span>Что </span>
              <span>входит </span>
              <span>в стоимость </span>
              <span>перевозки?</span>
            </div>
            <div className={styles.text} data-animation-order={2}>
              <span>Правда, </span>
              <span>что железнодорожный </span>
              <span>транспорт </span>
              <span>экологичнее </span>
              <span>других </span>
              <span>способов </span>
              <span>доставки?</span>
            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_4}`}>
          <div className={styles.container}>
            <div className={styles.text} data-animation-order={0}>
              <span>Чтобы </span>
              <span>ответить </span>
              <span>на эти </span>
              <span>и другие </span>
              <span>вопросы, </span>
              <span>предлагаем проследить </span>
              <span>путешествие </span>
              <span>груза </span>
              <span>по одному </span>
              <span>из самых </span>
              <span>востребованных </span>
              <span>нашими клиентами </span>
              <span>маршруту — </span>
              <span>от Чунцина </span>
              <span>до Дуйсбурга</span>
            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_5}`}>
          <div className={styles.container}>
            <h3 className={styles.h3} data-animation-order={0}>
              <span>Внимание, </span> <br />
              <span>поезд </span>
              <span>отправляется!</span>
            </h3>
            <div className={styles.text} data-animation-order={1}>
              <span>Путешествие </span>
              <span>поезда </span>
              <span>по транзитному </span>
              <span>участку </span>
              <span>маршрута </span>
              <span>Чунцин — </span>
              <span>Дуйсбург </span>
              <span>начинается </span>
              <span>на погранпереходах </span>
              <span>между Китаем </span>
              <span>и Казахстаном: </span>
              <span>станциях </span>
              <span>Достык </span>
              <span>или Алтынколь</span>
            </div>
          </div>
        </div>


        <div className={`${styles.slide} ${styles.slide_6}`}>
          <div className={styles.container}>
            <div className={styles.text} data-animation-order={0}>
              <span>Сотрудник </span>
              <span>ОТЛК ЕРА </span>
              <span>отправляет </span>
              <span>клиенту </span>
              <span>инструкцию </span>
              <span>по заполнению </span>
              <span>накладных</span>
            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_7}`}>
          <div className={styles.container}>
            <div className={styles.text} data-animation-order={0}>
              <span>Все заполненные </span>
              <span>документы </span>
              <span>мы обязательно </span>
              <span>проверяем, </span>
              <span>чтобы </span>
              <span>груз </span>
              <span>успешно </span>
              <span>пересёк </span>
              <span>границы</span>
            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_8}`}>
          <div className={styles.container}>
            <div className={styles.text} data-animation-order={0}>
              <span>Из </span>
              <span>города </span>
              <span>Чунцин </span>
              <span>до Достыка </span>
              <span>или Алтынколя </span>
              <span>груз </span>
              <span>в контейнерах </span>
              <span>везёт </span>
              <span>китайский </span>
              <span>перевозчик</span>
            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_9}`}>
          <div className={styles.container}>
            <h3 className={styles.h3} data-animation-order={0}>

              <span>На станции </span>
              <span>Достык </span>
              <span>контейнеры </span>
              <span>из Чунцина </span>
              <span>переходят </span>
              <span>в сервис </span>
              <span>ОТЛК ЕРА</span>
            </h3>
          </div>
        </div>
        <div className={`${styles.slide} ${styles.slide_10}`}>
          <div className={styles.container}>
            <h3 className={styles.h3} data-animation-order={0}>
              <span>Перегруз </span>
              <span>контейнеров </span>
              <span>с узкой </span>
              <span>колеи </span>
              <span>на широкую </span>
              <span>обеспечивает </span>
              <span>ОТЛК ЕРА</span>
            </h3>
            <div className={styles.play} onClick={() => { updatePlayPopup(true) }} data-animation-order={1}>
              <svg width="92" height="98" viewBox="0 0 92 98" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 4L88 49L4 94V4Z" stroke="white" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round" />
              </svg>

            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_11}`}>
          <div className={styles.container}>
            <h3 className={styles.h3} data-animation-order={0}>
              <span>Менее </span>
              <span>24 часов </span>
              <span>занимает </span>
              <span>перегрузка </span>
              <span>контейнеров</span>
            </h3>
            <div className={styles.clock} data-animation-order={1}>
              <div className={styles.clock__bg}>
                <svg width="944" height="944" viewBox="0 0 944 944" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="470.705" width="2.58867" height="31.9269" fill="#ABABAB" />
                  <rect x="470.705" y="912.074" width="2.58867" height="31.9269" fill="#ABABAB" />
                  <rect x="944" y="470.707" width="2.58867" height="31.9269" transform="rotate(90 944 470.707)" fill="#ABABAB" />
                  <rect x="31.9268" y="470.707" width="2.58867" height="31.9269" transform="rotate(90 31.9268 470.707)" fill="#ABABAB" />
                  <rect x="706.879" y="62.5898" width="2.58867" height="31.9269" transform="rotate(30 706.879 62.5898)" fill="#ABABAB" />
                  <rect x="250.842" y="852.469" width="2.58867" height="31.9269" transform="rotate(30 250.842 852.469)" fill="#ABABAB" />
                  <rect x="880.117" y="234.879" width="2.58867" height="31.9269" transform="rotate(60 880.117 234.879)" fill="#ABABAB" />
                  <rect x="90.2388" y="690.918" width="2.58867" height="31.9269" transform="rotate(60 90.2388 690.918)" fill="#ABABAB" />
                  <rect x="235.05" y="64.2422" width="3.19835" height="31.9835" transform="rotate(-30 235.05 64.2422)" fill="#ABABAB" />
                  <rect x="690.816" y="853.652" width="3.19835" height="31.9835" transform="rotate(-30 690.816 853.652)" fill="#ABABAB" />
                  <rect x="62.9604" y="237.508" width="3.19835" height="31.9835" transform="rotate(-60 62.9604 237.508)" fill="#ABABAB" />
                  <rect x="852.371" y="693.273" width="3.19835" height="31.9835" transform="rotate(-60 852.371 693.273)" fill="#ABABAB" />
                </svg>

              </div>
              <div className={styles.clock__second}></div>
              <div className={styles.clock__minute}></div>
              <div className={styles.clock__hour}></div>
              <div className={styles.clock__circle}></div>
            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_12}`}>
          <div className={styles.container}>
            <div className={styles.text} data-animation-order={0}>
              <span>Состав </span>
              <span>с грузом </span>
              <span>отправляется </span>
              <span>в сторону </span>
              <span>европейской </span>
              <span>границы</span>
            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_13}`}>
          <div className={styles.container}>
            <h2 className={styles.h2} data-animation-order={0}>

              <span>Как </span>
              <span>мы </span>
              <span>работаем</span>
            </h2>
            <div className={styles.text} data-animation-order={1}>
              <span>ОТЛК ЕРА — </span>
              <span>компания </span>
              <span>формата </span>
              <span>B2B, </span>
              <span>мы отправляем </span>
              <span>грузы </span>
              <span>полносоставными </span>
              <span>контейнерными </span>
              <span>поездами</span>
            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_14}`}>
          <div className={styles.container}>
            <h2 className={styles.h2} data-animation-order={1}>
              <span>Как </span>
              <span>мы </span>
              <span>работаем</span>
            </h2>
            <div className={styles.text} data-animation-order={0}>
              <span>Обеспечиваем </span>
              <span>фитинговые </span>
              <span>платформы </span>
              <span>под </span>
              <span>каждый </span>
              <span>контейнер</span>
            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_15}`}>
          <div className={styles.container}>
            <h2 className={styles.h2} data-animation-order={0}>
              <span>Как </span>
              <span>мы </span>
              <span>работаем</span>
            </h2>
            <div className={styles.text} data-animation-order={1}>
              <span>Перевозим </span>
              <span>грузы </span>
              <span>от границы </span>
              <span>к границе </span>
              <span>в пределах </span>
              <span>колеи </span>
              <span>1520 мм</span>
            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_16}`}>
          <div className={styles.container}>
            <h2 className={styles.h2} data-animation-order={0}>
              <span>Как </span>
              <span>мы </span>
              <span>работаем</span>
            </h2>
            <div className={styles.text} data-animation-order={1}>
              <span>Готовые </span>
              <span>к перевозке </span>
              <span>контейнеры </span>
              <span>предоставляет </span>
              <span>клиент</span>
            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_17}`}>
          <div className={styles.container}>
            <div className={styles.col}>
              <h2 className={styles.h2} data-animation-order={0}>
                <span>Что </span>
                <span>входит </span>
                <span>в ставку</span>
              </h2>
              <div className={styles.text} data-animation-order={1}>
                <span>Все </span>
                <span>необходимые </span>
                <span>для успешного </span>
                <span>транзита </span>
                <span>услуги </span>
                <span>и пошлины </span>
                <span>включены </span>
                <span>в стоимость </span>
                <span>перевозки</span>
              </div>
              <div className={`${styles.qr}`} data-animation-order={2}>
                <img src={`${path}/img/qr-code-2.webp`} alt="" />
                <div className={styles.text} data-animation-order={3}>

                  <span>Рассчитать </span>
                  <span>ставку </span>
                  <span>на нашем </span>
                  <span>сайте </span>
                </div>
              </div>
            </div>
            <div className={styles.col}>
              <ul className={styles.ul} data-animation-order={4}>
                <li><span className={styles.li__icon}>
                  <img src={`${path}/img/li-icon-1.svg`} alt="" />
                </span>Ж/д тариф по Казахстанской, Российским и Белорусской железным дорогам</li>
                <li><span className={styles.li__icon}>
                  <img src={`${path}/img/li-icon-2.svg`} alt="" />
                </span>Сборы за сменное сопровождение грузов</li>
                <li><span className={styles.li__icon}>
                  <img src={`${path}/img/li-icon-3.svg`} alt="" />
                </span>Услуги по таможенному оформлению грузов</li>
                <li><span className={styles.li__icon}>
                  <img src={`${path}/img/li-icon-4.svg`} alt="" />
                </span>Сбор за таможенный осмотр грузов</li>
                <li><span className={styles.li__icon}>
                  <img src={`${path}/img/li-icon-5.svg`} alt="" />
                </span>Погрузо-разгрузочные операции при смене колеи на территории ЕАЭС</li>
                <li><span className={styles.li__icon}>
                  <img src={`${path}/img/li-icon-6.svg`} alt="" />
                </span>Предоставление фитинговой платформы</li>
              </ul>
            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_18}`}>
          <div className={styles.container}>
            <div className={styles.col}>
              <h2 className={styles.h2} data-animation-order={0}>
                <span>Что </span>
                <span>мы </span>
                <span>перевозим</span>
              </h2>
              <div className={styles.text} data-animation-order={1}>
                <span>Мы готовы </span>
                <span>отправить </span>
                <span>любой </span>
                <span>вид </span>
                <span>груза, </span>
                <span>который </span>
                <span>разрешено </span>
                <span>транспортировать </span>
                <span>контейнерными </span>
                <span>поездами</span>
              </div>
            </div>
            <div className={styles.col}>
              <h4 className={styles.h4} data-animation-order={2}>
                <span>Основные </span>
                <span>типы </span>
                <span>грузов</span>
              </h4>
              <ul className={styles.ul} data-animation-order={3}>
                <li><span className={styles.li__icon}>
                  <img src={`${path}/img/li-icon-7.svg`} alt="" />
                </span>Электрические устройства и аппаратура связи</li>
                <li><span className={styles.li__icon}>
                  <img src={`${path}/img/li-icon-8.svg`} alt="" />
                </span>Механическое оборудование и техника</li>
                <li><span className={styles.li__icon}>
                  <img src={`${path}/img/li-icon-9.svg`} alt="" />
                </span>Одежда швейная и трикотажная</li>
                <li><span className={styles.li__icon}>
                  <img src={`${path}/img/li-icon-10.svg`} alt="" />
                </span>Автотехника и запчасти</li>
                <li><span className={styles.li__icon}>
                  <img src={`${path}/img/li-icon-11.svg`} alt="" />
                </span>Пластмассы и изделия из них</li>
                <li><span className={styles.li__icon}>
                  <img src={`${path}/img/li-icon-12.svg`} alt="" />
                </span>Продукты неорганической химии</li>
                <li><span className={styles.li__icon}>
                  <img src={`${path}/img/li-icon-13.svg`} alt="" />
                </span>Оптика, приборы, медтехника</li>
                <li><span className={styles.li__icon}>
                  <img src={`${path}/img/li-icon-14.svg`} alt="" />
                </span>Прочие разрешённые грузы</li>
              </ul>
            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_19}`}>
          <div className={styles.container}>
            <h4 className={styles.h4} data-animation-order={2}>
              <span>Ваши </span>
              <span>контейнеры </span>
              <span>с грузом</span>
            </h4>
            <a href="https://" className={styles.link} data-animation-order={3}>
              <span>
                <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.52778 16.9542C3.8794 19.1776 6.00841 20.82 8.50209 21.5629C10.9958 22.3058 13.6765 22.0964 16.0245 20.9752C18.3725 19.854 20.2206 17.9009 21.2105 15.4945C22.2004 13.0882 22.2615 10.4 21.3821 7.95113C20.5026 5.50227 18.7453 3.46717 16.4506 2.24036C14.156 1.01355 11.4876 0.68243 8.96273 1.31119C6.43785 1.93995 4.23637 3.48381 2.78506 5.64345C1.33375 7.8031 0.736013 10.4247 1.10772 13" stroke="#67D672" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M9.82339 16.9571V6.47363H14.0336C14.7007 6.47364 15.3404 6.73861 15.812 7.21027C16.2837 7.68192 16.5486 8.32163 16.5486 8.98865C16.5486 9.65567 16.2837 10.2954 15.812 10.767C15.3403 11.2387 14.7006 11.5037 14.0336 11.5037H7.32227" stroke="#67D672" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M7.32227 14.791H12.6079" stroke="#67D672" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>Рассчитать ставку</span>
            </a>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_20}`}>
          <div className={styles.container}>
            <h2 className={styles.h2} data-animation-order={0}>
              <span>В перечне </span>
              <span>перевозимых </span>
              <span>грузов </span>
              <span>90+ </span>
              <span>кодов </span>
              <span>ТН </span>
              <span>ВЭД</span>
            </h2>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_21}`}>
          <div className={styles.container}>
            <div className={styles.col}>
              <h2 className={styles.h2} data-animation-order={0}>
                <span>Сквозная </span>
                <span>технология </span>
                <span>перевозок</span>
              </h2>
            </div>
            <div className={styles.col}>
              <div className={styles.text} data-animation-order={1}>
                <span>Погранпереходы </span>
                <span>между </span>
                <span>странами </span>
                <span>поезд </span>
                <span>проезжает </span>
                <span>без </span>
                <span>остановок.</span>
              </div>
              <div className={styles.text} data-animation-order={2}>
                <span>Наша </span>
                <span>компания </span>
                <span>координирует </span>
                <span>взаимодействие </span>
                <span>железнодорожных </span>
                <span>администраций </span>
                <span>на протяжении </span>
                <span>всего </span>
                <span>маршрута</span>
              </div>
            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_22}`}>
          <div className={styles.container}>
            <h2 className={styles.h2} data-animation-order={0}>
              <span>Срок </span>
              <span>транзита </span>
              <span>по широкой </span>
              <span>колее </span>
              <span>составляет </span>
              <span>5–7 суток</span>
            </h2>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_23}`}>
          <div className={styles.container}>
            <div className={styles.col}>
              <div className={styles.desc} data-animation-order={2}>
                <span>Почему </span>
                <span>выбирают </span>
                <span>нас</span>
              </div>
              <h4 className={styles.h4} data-animation-order={3}>
                <span>Доставляем </span>
                <span>быстро </span>
                <span>и в срок</span>
              </h4>
              <div className={styles.text} data-animation-order={4}>
                <span>На транзитном </span>
                <span>пути нет </span>
                <span>высокогорных </span>
                <span>участков, </span>
                <span>поезд </span>
                <span>движется </span>
                <span>со стабильной </span>
                <span>скоростью, </span>
                <span>точно </span>
                <span>следуя </span>
                <span>графику</span>
              </div>
            </div>
            <div className={styles.col}>
              <h3 className={styles.h3} data-animation-order={0}>
                <span>865 </span>
                <span>км/сутки</span>
              </h3>
              <div className={styles.text} data-animation-order={1}>
                <span>средняя </span>
                <span>скорость </span>
                <span>состава </span>
                <span>в направлении </span>
                <span>Китай — </span>
                <span>Европа</span>
              </div>
            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_23_1} ${styles.slide_mobile}`}>
          <div className={styles.container}>
            <div className={styles.desc} data-animation-order={2}>
              <span>Почему </span>
              <span>выбирают </span>
              <span>нас</span>
            </div>
            <h3 className={styles.h3} data-animation-order={0}>
              <span>865 </span>
              <span>км/сутки</span>
            </h3>
            <div className={styles.text} data-animation-order={1}>
              <span>средняя </span>
              <span>скорость </span>
              <span>состава </span>
              <span>в направлении </span>
              <span>Китай — </span>
              <span>Европа</span>
            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_24}`}>
          <div className={styles.container}>
            <div className={styles.col}>
              <div className={styles.desc} data-animation-order={2}>
                <span>Почему </span>
                <span>выбирают </span>
                <span>нас</span>
              </div>
              <h4 className={styles.h4} data-animation-order={3}>
                <span>Регулярно </span>
                <span>отправляем </span>
                <span>контейнерные </span>
                <span>грузы</span>
              </h4>
              <div className={styles.text} data-animation-order={4}>
                <span>Планировать </span>
                <span>доставку </span>
                <span>гораздо </span>
                <span>проще, </span>
                <span>если </span>
                <span>маршрут </span>
                <span>работает </span>
                <span>стабильно. </span>
                <span>Мы управляем </span>
                <span>большим </span>
                <span>парком </span>
                <span>платформ </span>
                <span>и готовы </span>
                <span>оперативно </span>
                <span>принять </span>
                <span>контейнер </span>
                <span>к перевозке</span>
              </div>
            </div>
            <div className={styles.col}>
              <h3 className={styles.h3} data-animation-order={0}>
                <span>9000+ </span>
                <span>платформ</span>
              </h3>
              <div className={styles.text} data-animation-order={1}>
                <span>для </span>
                <span>перевозки </span>
                <span>контейнеров </span>
                <span>находится </span>
                <span>в управлении </span>
                <span>ОТЛК ЕРА</span>
              </div>
            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_24_1} ${styles.slide_mobile}`}>
          <div className={styles.container}>
            <div className={styles.desc} data-animation-order={2}>
              <span>Почему </span>
              <span>выбирают </span>
              <span>нас</span>
            </div>
            <h3 className={styles.h3} data-animation-order={0}>
              <span>9000+ </span>
              <span>платформ</span>
            </h3>
            <div className={styles.text} data-animation-order={1}>
              <span>для </span>
              <span>перевозки </span>
              <span>контейнеров </span>
              <span>находится </span>
              <span>в управлении </span>
              <span>ОТЛК ЕРА</span>
            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_25}`}>
          <div className={styles.container}>
            <div className={styles.col}>
              <div className={styles.desc} data-animation-order={2}>
                <span>Почему </span>
                <span>выбирают </span>
                <span>нас</span>
              </div>
              <h4 className={styles.h4} data-animation-order={3}>

                <span>Обеспечиваем </span>
                <span>безопасность</span>
              </h4>
              <div className={styles.text} data-animation-order={4}>
                <span>Поезд </span>
                <span>не может </span>
                <span>отклониться </span>
                <span>от заданного </span>
                <span>маршрута </span>
                <span>и находится </span>
                <span>под контролем </span>
                <span>на протяжении </span>
                <span>всего </span>
                <span>пути </span>
                <span>следования</span>
              </div>
            </div>
            <div className={styles.col}>
              <h3 className={styles.h3} data-animation-order={0}>
                <span>99,97%</span>
              </h3>
              <div className={styles.text} data-animation-order={1}>
                <span>уровень </span>
                <span>сохранности </span>
                <span>грузов </span>
                <span>при транзитной </span>
                <span>перевозке </span>
                <span>ОТЛК ЕРА</span>
              </div>
            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_25_1} ${styles.slide_mobile}`}>
          <div className={styles.container}>
            <div className={styles.desc} data-animation-order={2}>
              <span>Почему </span>
              <span>выбирают </span>
              <span>нас</span>
            </div>

            <h3 className={styles.h3} data-animation-order={0}>
              <span>99,97%</span>
            </h3>
            <div className={styles.text} data-animation-order={1}>
              <span>уровень </span>
              <span>сохранности </span>
              <span>грузов </span>
              <span>при транзитной </span>
              <span>перевозке </span>
              <span>ОТЛК ЕРА</span>
            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_26}`}>
          <div className={styles.container}>
            <div className={styles.col}>
              <div className={styles.desc} data-animation-order={1}>
                <span>Почему </span>
                <span>выбирают </span>
                <span>нас</span>
              </div>
              <h4 className={styles.h4} data-animation-order={2}>
                <span>Не зависим </span>
                <span>от погодных </span>
                <span>условий</span>
              </h4>
            </div>
            <div className={styles.col}>
              <div className={styles.text} data-animation-order={0}>
                <span>Плохая </span>
                <span>видимость, </span>
                <span>штормовой </span>
                <span>ветер </span>
                <span>или дождь </span>
                <span>в меньшей </span>
                <span>степени </span>
                <span>влияют </span>
                <span>на перевозку </span>
                <span>груза </span>
                <span>по железной </span>
                <span>дороге, </span>
                <span>в отличие </span>
                <span>от других </span>
                <span>способов </span>
                <span>транспортировки</span>
              </div>
            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_27}`}>
          <div className={styles.container}>
            <div className={styles.col}>
              <div className={styles.desc} data-animation-order={2}>
                <span>Почему </span>
                <span>выбирают </span>
                <span>нас</span>
              </div>
              <h4 className={styles.h4} data-animation-order={3}>
                <span>Сокращаем </span>
                <span>количество </span>
                <span>выбросов</span>
              </h4>
            </div>
            <div className={styles.col}>
              <h3 className={styles.h3} data-animation-order={0}>
                <span>В 600</span> <span>раз</span>
              </h3>
              <div className={styles.text} data-animation-order={1}>
                <span>сократили </span>
                <span>количество </span>
                <span>прямых </span>
                <span>выбросов </span>
                <span>СО<sub>2</sub> </span>
                <span>компании, </span>
                <span>перешедшие </span>
                <span>с авиадоставки  </span>
                <span>на ж/д </span>
                <span>в 2022 году</span>
              </div>
            </div>
            <div className={styles.qr} data-animation-order={4}>
              <img src={`${path}/img/qr-code.webp`} alt="" />
              <div className={styles.text} data-animation-order={5}>
                <span>Разработанный </span>
                <span>нашей </span>
                <span>компанией </span>
                <span>счётчик </span>
                <span>углеродных </span>
                <span>выбросов </span>
                <span>наглядно </span>
                <span>подтверждает </span>
                <span>экологические </span>
                <span>преимущества </span>
                <span>доставки </span>
                <span>грузов </span>
                <span>по железной </span>
                <span>дороге</span>
              </div>
              <a href="https://" className={styles.link} data-animation-order={6}>
                <span>
                  <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.882 13.3544L11.8896 16.9328L7.88199 13.3292" stroke="#67D672" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M15.8576 7.99982L11.8818 11.5633L7.89087 7.97465" stroke="#67D672" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M7.58806 20.6441C5.64226 19.7278 4.04906 18.2124 3.04853 16.3263C2.048 14.4402 1.69436 12.2857 2.0409 10.1873C2.38743 8.08893 3.41536 6.16044 4.9698 4.69244C6.52424 3.22443 8.52096 2.29644 10.6591 2.04831C12.7972 1.80018 14.9609 2.24534 16.824 3.31672C18.6872 4.38811 20.149 6.02766 20.989 7.98832C21.8291 9.94897 22.0019 12.1245 21.4815 14.1871C20.961 16.2497 19.2929 18.6411 16.1669 20.4509" stroke="#67D672" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  Перейти в счётчик выбросов CO<sub>2</sub></span>
              </a>
            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_27_1} ${styles.slide_mobile}`}>
          <div className={styles.container}>
            <div className={styles.desc} data-animation-order={2}>
              <span>Почему </span>
              <span>выбирают </span>
              <span>нас</span>
            </div>

            <h3 className={styles.h3} data-animation-order={0}>
              <span>В 600</span> <span>раз</span>
            </h3>
            <div className={styles.text} data-animation-order={1}>
              <span>сократили </span>
              <span>количество </span>
              <span>прямых </span>
              <span>выбросов </span>
              <span>СО<sub>2</sub> </span>
              <span>компании, </span>
              <span>перешедшие </span>
              <span>с авиадоставки  </span>
              <span>на ж/д </span>
              <span>в 2022 году</span>
            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_28}`}>
          <div className={styles.container}>
            <h2 className={styles.h2} data-animation-order={0}>
              <span>На </span>
              <span>границе </span>
              <span>с Европой</span>
            </h2>
            <div className={styles.text} data-animation-order={1}>
              <span>Поезд </span>
              <span>прибывает </span>
              <span>на границу </span>
              <span>Беларуси </span>
              <span>и Польши — </span>
              <span>станцию </span>
              <span>Брест. </span>
              <span>Здесь </span>
              <span>заканчивается </span>
              <span>наше </span>
              <span>путешествие </span>
              <span>и сервис </span>
              <span>ОТЛК ЕРА</span>
            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_29}`}>
          <div className={styles.container}>
            <div className={styles.text} data-animation-order={0}>
              <span>В Бресте </span>
              <span>контейнеры </span>
              <span>с грузом </span>
              <span>принимает </span>
              <span>европейский </span>
              <span>перевозчик </span>
              <span>и перегружает </span>
              <span>их на </span>
              <span>узкую </span>
              <span>колею </span>
              <span>для </span>
              <span>отправки </span>
              <span>в Дуйсбург</span>
            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_30}`}>
          <div className={styles.container}>
            <div className={styles.text} data-animation-order={0}>
              <span>На порожние </span>
              <span>платформы </span>
              <span>ОТЛК  ЕРА </span>
              <span>загружает </span>
              <span>контейнеры </span>
              <span>с грузом </span>
              <span>из Европы</span>
            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_31}`}>
          <div className={styles.container}>
            <div className={styles.text} data-animation-order={0}>
              <span>Состав </span>
              <span>отправляется </span>
              <span>обратно </span>
              <span>к станциям </span>
              <span>Достык </span>
              <span>или Алтынколь, </span>
              <span>откуда </span>
              <span>груз </span>
              <span>поедет </span>
              <span>в Китай</span>
            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_32}`}>
          <div className={styles.container}>
            <h3 className={styles.h3} data-animation-order={1}>
              <span>Соединяя </span>
              <span>Запад </span>
              <span>и Восток</span>
            </h3>
            <div className={styles.text} data-animation-order={0}>
              <span>ОТЛК ЕРА —  </span>
              <span>оператор </span>
              <span>железнодорожных </span>
              <span>транзитных </span>
              <span>контейнерных </span>
              <span>сервисов </span>
              <span>на территории </span>
              <span>Евразийского </span>
              <span>экономического </span>
              <span>союза</span>
            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_33}`}>
          <div className={styles.container}>
            <div className={styles.text} data-animation-order={0}>
              <span>Мы перевозим </span>
              <span>контейнеры </span>
              <span>на маршрутах </span>
              <span>Китай — </span>
              <span>Европа — </span>
              <span>Китай </span>
              <span>в составе </span>
              <span>регулярных </span>
              <span>контейнерных </span>
              <span>поездов </span>
              <span>через </span>
              <span>территории </span>
              <span>Казахстана, </span>
              <span>России </span>
              <span>и Беларуси</span>
            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_34}`}>
          <div className={styles.container}>
            <h3 className={styles.h3} data-animation-order={0}>
              <span>Ежесуточно </span>
              <span>отправляем </span> <br />
              <span>20–30 </span>
              <span>поездов</span>
            </h3>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_35}`}>
          <div className={styles.container}>
            <h3 className={styles.h3} data-animation-order={0}>
              <span>Перевозим </span>
              <span>контейнеры </span>
              <span>по 600+ </span>
              <span>маршрутам </span>
              <span>между </span>
              <span>Китаем </span>
              <span>и Европой</span>
            </h3>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_36}`}>
          <div className={styles.container}>
            <div className={styles.text} data-animation-order={0}>
              <span>Обеспечиваем </span>
              <span>89,3% </span>
              <span>от всего </span>
              <span>объёма </span>
              <span>транзитных </span>
              <span>контейнерных </span>
              <span>ж/д перевозок </span>
              <span>Китай — </span>
              <span>Европа — </span>
              <span>Китай</span>
            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_37}`}>
          <div className={styles.container}>
            <div className={styles.text} data-animation-order={0}>
              <span>ОТЛК ЕРА — </span>
              <span>совместный </span>
              <span>интеграционный </span>
              <span>проект </span>
              <span>трёх </span>
              <span>паритетных </span>
              <span>участников</span>
            </div>
          </div>
        </div>

        <div className={`${styles.slide} ${styles.slide_38}`}>
          <div className={styles.container}>
            <div className={styles.col}>

              <h2 className={styles.h2} data-animation-order={0}>
                <span>Ваш </span>
                <span>следующий </span>
                <span>шаг</span>
              </h2>
            </div>
            <div className={styles.col}>

              <div className={styles.text} data-animation-order={1}>
                <span>Хотите </span>
                <span>организовать </span>
                <span>перевозку </span>
                <span>контейнеров </span>
                <span>с использованием </span>
                <span>сервиса </span>
                <span>ОТЛК ЕРА? </span>
              </div>

              <div className={`${styles.qr}`} data-animation-order={2}>
                <img src={`${path}/img/qr-code-3.webp`} alt="" />
                    <a href="https://" className={styles.link} data-animation-order={3}>
                      <span>
                        <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M20 3.5V3C20 1.89543 19.1046 1 18 1H3C1.89543 1 1 1.89543 1 3V13C1 14.1046 1.89543 15 3 15H3.8503C4.76141 15 5.5 15.7386 5.5 16.6497V16.6497C5.5 18.0184 7.07066 18.7918 8.15553 17.9573L11.4608 15.4148C11.8104 15.1458 12.2392 15 12.6802 15H18C19.1046 15 20 14.1046 20 13V10.25V8.5M5.5 6H16M5.5 10.5H12.5" stroke="#67D672" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        Свяжитесь с нами</span>
                    </a>
                    <div className={styles.text} data-animation-order={3}>
                      <span>Обратитесь </span>
                      <span>к нашему </span>
                      <span>сотруднику </span>
                      <span>или свяжитесь </span>
                      <span>с нами </span>
                      <span>через </span>
                      <span>сайт</span>
                    </div>
              </div>
              <div className={styles.again} data-animation-order={4} onClick={() => { updateStage(0) }}>
                {isMobile ?
                  <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M25.7358 11.3862L21.6347 15.0816L17.4947 11.3861" stroke="#67D672" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M17.5823 20.4522C15.9142 21.4981 13.9514 21.9736 11.9895 21.8069C10.0277 21.6403 8.17315 20.8405 6.70539 19.5281C5.23764 18.2158 4.23617 16.4619 3.85192 14.5308C3.46767 12.5998 3.72144 10.5962 4.575 8.82188C5.42856 7.04761 6.83566 5.59881 8.58425 4.69382C10.3329 3.78882 12.3282 3.47666 14.2697 3.80437C16.2111 4.13208 17.9935 5.0819 19.3481 6.51072C20.7028 7.93953 21.752 10.4181 21.6333 13.7327" stroke="#67D672" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  :
                  <svg width="73" height="69" viewBox="0 0 73 69" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M70.5002 31.0895L59.3031 41.1789L48 31.0892" stroke="#67D672" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M48.2412 55.8396C43.6868 58.6954 38.3277 59.9935 32.9714 59.5385C27.615 59.0834 22.5517 56.8998 18.5443 53.3167C14.537 49.7336 11.8028 44.9451 10.7537 39.6729C9.70456 34.4006 10.3974 28.9302 12.7279 24.086C15.0583 19.2418 18.9 15.2862 23.6741 12.8153C28.4482 10.3444 33.8961 9.49216 39.1967 10.3869C44.4974 11.2816 49.3636 13.8749 53.0622 17.7759C56.7608 21.6769 59.6253 28.4441 59.3013 37.4937" stroke="#67D672" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                }
                <span>Пройти маршрут снова</span>
              </div>
            </div>
          </div>
        </div>


      </div>
    </>
  );

}

export default SlidesMain;
